export default __webpack_public_path__ + "static/media/md-card-bg-track-cybersecurity.934d31ad.png";